define('SageDotCom/PatternAnimations/animatedBoxes',[
    "jquery",
    "ScrollMagic",
    "TweenMax",
    "AnimationPlugin"
],
    function (
        $,
        ScrollMagic,
        TweenMax,
        AnimationPlugin
    ) {

    function animatedBoxes() { }

    animatedBoxes.prototype.initialize = function () {

        var boxes = {
            panes: {},
            tablet: '600',
            viewportHeight: '',
            viewportWidth: '',
            controller: ''
        };

        function isEven(n) {
            return n % 2 == 0;
        }

        function isOdd(n) {
            return Math.abs(n % 2) == 1;
        }

        function generateRandomNumber(max, min) {
            return Math.floor(window.getRandomNumber() * (max - min + 1)) + min;
        }

        function buildEntranceScene() {
            for (var i = 0; i < boxes.panes.length; i++) {
                var pane = boxes.panes[i];
                var entranceTimeLine = new TimelineMax();
                var number

                if (boxes.viewportWidth > boxes.tablet && isEven(i + 1)) {
                    entranceTimeLine.fromTo(pane, 0.25, { yPercent: generateRandomNumber(10, 5)*-1}, { yPercent: 0 });
                } else if (boxes.viewportWidth > boxes.tablet && isOdd(i + 1)) {
                    entranceTimeLine.fromTo(pane, 0.25, { yPercent: generateRandomNumber(10, 5)}, { yPercent: 0 });
                }

                new ScrollMagic.Scene({
                    triggerElement: pane,
                    duration: '50%',
                    triggerHook: 'onEnter'
                })
                .setTween(entranceTimeLine)
                .addTo(boxes.controller);
            }
        }

        function buildExitScene() {
            for (var i = 0; i < boxes.panes.length; i++) {
                var pane = boxes.panes[i];
                var exitTimeLine = new TimelineMax();

                if (boxes.viewportWidth > boxes.tablet && isEven(i + 1)) {
                    exitTimeLine.fromTo(pane, 0.25, { yPercent: 0 }, { yPercent: 0 });
                } else if (boxes.viewportWidth > boxes.tablet && isOdd(i + 1)) {
                    exitTimeLine.fromTo(pane, 0.25, { yPercent: 0 }, { yPercent: 0 });
                }

                new ScrollMagic.Scene({
                    triggerElement: pane,
                    duration: '50%',
                    triggerHook: -500
                })
                .setTween(exitTimeLine)
                // .addIndicators()
                .addTo(boxes.controller);
            }

        }

        var patternAnimations = document.querySelectorAll('.floating-boxes');
        if (patternAnimations.length) {
            patternAnimations.forEach(function (patternAnimation) {
                boxes.panes = patternAnimation.querySelectorAll('.flex-item');
                boxes.viewportHeight = window.innerHeight;
                boxes.viewportWidth = window.innerWidth;
                boxes.controller = new ScrollMagic.Controller();

                buildEntranceScene();
                buildExitScene();
            });
        }
    };
    return new animatedBoxes();
});

